import React from 'react';
import TextBlock from '../Components/TextBlock';
import Collaps from '../Components/Collaps';

const H3 = (props) => {
    return (
			<React.Fragment>
				<TextBlock name='Закриття ФОП (ФЛП, СПД, ЧП, ІП)'>
					<section className="s-text">
					Ви вирішили припинити свою підприємницьку діяльність, але не хочете вистоювати черги у державних службах та фондах, передавати документи кілька разів? Скористайтеся послугами професіоналів! Ми підготуємо та подамо документи в найкоротші терміни.
					</section>
				</TextBlock>

				<TextBlock name='Припинення діяльності ФОП'>
					<section className="s-text">
						
							
							Для проведення реєстрації припинення підприємницької діяльності можуть знадобитися:<br/>
							- паспортні відомості та ідентифікаційний номер; <br/>
							- електронний цифровий підпис, або застосунок "Дія", або нотаріально посвідчена довіреність на реєстрацію ФОП, або особиста присутність. <br/>
							Реєстрацію можна провести як в нашому офісі так і у зручному для вас місці або онлайн. <br/>
							<br/>
								До послуги входить: <br/>
								- внесення в ЄДР інформації про припинення підприємницької діяльності; <br/>
								- повідомлення податкової про припинення підприємницької діяльності; <br/>
								- повідомлення податкової про припинення підприємницької діяльності; <br/>
								- отримання виписки з ЄДР про припинення діяльності.<br/>
							
						</section>
						<section className="s-textb">
						Строк виконання 1-2 робочі дні.<br/>
						Вартість послуги - 400 грн.<br/>
						</section>
				</TextBlock>

				

				<TextBlock name='Додаткові послуги'>
					<section className="s-text">
					- Підготовка та подання ліквідаційних звітів - від 600 грн.<br/>
					- Допомога з погашенням заборгованостей - від 1000 грн.<br/>
					- Супровід податкової перевірки - від 3000 грн.<br/>
					- Допомога з поверненням надміру сплачених податків - від 2000 грн.<br/>

					</section>
					
				</TextBlock>

			</React.Fragment>
    );
  }

	export default H3;


// WEBPACK FOOTER //
// ./src/Page/H3.jsx